import React from 'react';
import { Link } from 'react-router-dom';

function Banner() {
  return (
    <div style={{ marginTop: '40px' }}>
      <section
        id="home"
        className="d-flex align-items-center"
        style={{
          backgroundColor: '#202E3F',
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'white',
          paddingTop: '0',
          marginTop: '0',
          textAlign: 'center', // ensure all text within section is centered
        }}
      >
        <div className="container">
          <div className="row justify-content-center align-items-center">
            <div
              className="col-lg-8 d-flex flex-column justify-content-center align-items-center text-center"
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <h1 className="mb-3 fw-bold">The Best Affordable Hosting</h1>
              <h2 className="mb-4">
                At only ₹1199 for a year | Renew at same price
              </h2>
              <ul className="list-unstyled fs-5 mb-4">
                <li>✓ 99.9% Uptime</li>
                <li>✓ NVMe SSD Storage</li>
                <li>✓ Free SSL Certificates</li>
              </ul>
              <div>
                <Link to="/hosting">
                  <span
                    className="btn btn-primary px-4 py-2 rounded-pill"
                    style={{ backgroundColor: '#375578' }}
                  >
                    Get Started
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Banner;
